// src/ThemeProviderWrapper.jsx
import React, { useEffect } from "react";
import { ThemeProvider } from "./theming";

const ThemeProviderWrapper = ({ children, theme }) => {
  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty("--color-accent", theme.accentColor || "#7e9aae");
    root.style.setProperty("--color-background", theme.backgroundColor || "#10202c");
    // Also drive Tailwind's `bg-background` utility so route transitions never
    // reveal the browser default white.
    root.style.setProperty("--background", theme.backgroundColor || "#10202c");
    root.style.backgroundColor = theme.backgroundColor || "#10202c";
    if (document.body) {
      document.body.style.backgroundColor = theme.backgroundColor || "#10202c";
    }
    root.style.setProperty("--color-text-primary", theme.textColor || "#fcfcfd");
    root.style.setProperty("--color-text-secondary", theme.secondaryColor || "#5d6a74");
    root.style.setProperty("--color-charcoal", theme.charcoal || "#333333");
    root.style.setProperty("--font-family-sans", theme.fontSans || "Inter, sans-serif");
    root.style.setProperty("--font-family-serif", theme.fontSerif || "Georgia, serif");
  }, [theme]);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default ThemeProviderWrapper;
